import { render, staticRenderFns } from "./RadarDeviceKanBan.vue?vue&type=template&id=40665438&scoped=true"
import script from "./RadarDeviceKanBan.vue?vue&type=script&lang=js"
export * from "./RadarDeviceKanBan.vue?vue&type=script&lang=js"
import style0 from "./RadarDeviceKanBan.vue?vue&type=style&index=0&id=40665438&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40665438",
  null
  
)

export default component.exports